<script setup lang="ts">
/**
 * リプライ0件時の表示。
 */

import { defineProps } from "vue";

interface Props {
	/**
	 * 「トークルームへのリプライがない時」文言
	 */
	noReplyText: string;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars, no-undef
const props = defineProps<Props>();
</script>

<template>
	<p class="revico-community-talk-talkroom-no-reply">{{ noReplyText }}</p>
</template>

<style lang="scss">
.revico-widget .revico-community-talk {
	.revico-community-talk-talkroom-no-reply {
		margin: 12px 0;
		text-align: center;
		white-space: pre-wrap;
	}
}
</style>
